export default __webpack_public_path__ + "static/media/cyberpunk-jacket2.97dbf9e9.jpg";